import React, {Fragment} from 'react';
import {
    DropdownToggle, DropdownMenu,
    Nav, NavItem, NavLink,
    UncontrolledButtonDropdown
} from 'reactstrap';
import { toast, Bounce } from 'react-toastify';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import 'react-toastify/dist/ReactToastify.css';
import {
    clearSessionValue,
    getSessionValue,
    handleErrorResponse,
    randomNumber,
    setSessionValue,
    getLogoutURL, getServerDomainURL,
    clearLegacyCookie,
    showToast, confirmBoxWithImage,
    getAppidFromCookie,
    getHostPrefix,
    getCookieByHost
} from "../Common/Appcommon";
import requestApi from "../services/requestApi.service";
import cx from "classnames";
import {getInitials} from "../Components/Inbox/utils/common";
import CratioTooltip from "../Common/CratioTooltip";
import { faAngleDown, faLaptopHouse, faMagnifyingGlass, faX, faXmark } from '@fortawesome/free-solid-svg-icons';
import { subscribeNotification } from "../Components/Notifications/firebase";
import { Form } from 'react-bootstrap';
import { Loader } from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";

class UserBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            dropDownIsOpen: false,
            searchActive : false,
            searchTxt : "",
            showLoader : false,
            openUserStatus : false,
            showUserLoader : false,
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.templateHolderRef = React.createRef(null);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.dropDownIsOpen && this.templateHolderRef.current && !this.templateHolderRef.current.contains(event.target)) {
            this.setState({
                dropDownIsOpen: false
            })
        }
    }

    notify2 = () => this.toastId = toast("You don't have any new items in your calendar for today! Go out and play!", {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: 'bottom-center',
        type: 'success'
    });

    logoutApp = async (e) =>{
        let activeSessionCount = 1;
        let params = {
            "ENTITY" : "session_check",
        } 
        let appid = getAppidFromCookie();
        let prefix = getHostPrefix();
        let cpanelemail = getCookieByHost(prefix + 'cpanelemail');
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            activeSessionCount = response.data['activeSessions'];
            if (activeSessionCount > 1) {
                let logOutAllDev = await confirmBoxWithImage("Logout Confirmation","Are you sure you want to Logout?",'',"Logout From All Devices","Logout From This Device","","",false,false,true);
                if (logOutAllDev !== "Close") {
                    let params = {
                        "ENTITY": "logout",
                        'logoutfromall': logOutAllDev,
                        'cpanelloginname':cpanelemail
                    };
                    setTimeout(async () => {
                        clearLegacyCookie();
                        let response = await requestApi.processServerRequest(params);
                        if (response.issuccess) {
                            clearSessionValue();
                            if(response.data != ""){
                                window.location = response.data; 
                            }else{
                                window.location = getLogoutURL();       
                            }
                        } else {
                            handleErrorResponse(response.errormsg);
                        }
                    }, 500);
                }
            } else {
                let params = {
                    "ENTITY": "logout",
                    'logoutfromall': false,
                    'cpanelloginname':cpanelemail
                };
                clearLegacyCookie();
                let response = await requestApi.processServerRequest(params);
                if (response.issuccess) {
                    clearSessionValue();
                    if(response.data != "" ){
                        window.location = response.data; 
                    }else{
                        window.location = getLogoutURL();       
                    }
                } else {
                    handleErrorResponse(response.errormsg);
                }
            }
        }else {
            handleErrorResponse(response.errormsg);
        }
    }        
    openGivenUrl= async (e) =>{
        let appid = getSessionValue('appid');
        let serverURL = getServerDomainURL();
        if(serverURL === "https://apps.cratiocrm.com"){
            window.location = serverURL+"/crm.html";
        }else{
            window.location = serverURL+"/"+appid+".html";
        }
    }

    showUserInfo = async (e) => {
        const userId = getSessionValue('loginuserid');
        window.location = `#/settings/account/users/${userId}`;
    }

    changePassword = () => {
        setSessionValue('changePwd','true');
        window.location.reload();
    }

    subscribeToNotification = async (e) => {
        e.preventDefault();
        this.setState({
            showLoader : true
        });
        subscribeNotification(this.subscribeCallback);
    };
    
    subscribeCallback = async (data) => {
        if(data.issuccess){
            let params = {
                "ENTITY" : "GCM_PROCESS",
                "OPERATION" : "UPDATE_REGISTRATION_ID",
                "PLATFORM" : "Web",
                "regisid" : data.token,
                "userid" : getSessionValue('loginuserid'),
            }
            let response = await requestApi.processServerRequest(params);
            console.log("subscribe callback invoked",data);
            if(response.issuccess){
                setSessionValue("web_notification_status","Subscribed");
                showToast("Notification Subscribed.");
                this.setState({
                    showLoader : false
                });
            }
        } else {
            console.log(data.error);
            showToast(data.error);
            this.setState({
                showLoader : false
            });
        }
    };

    globalSearchAction = (e) => {
        let currentStatus = this.state.searchActive;
        this.setState({
            searchActive : !currentStatus
        });
    }

	/*detectEnterPress = (e) => {
		if ((e.key === "Enter" || e.keyCode === 13) && !e.shiftKey){
			this.performGlobalSearchOperation();
			e.preventDefault()
		}
	};*/

    performGlobalSearchOperation = (e) => {
        e.preventDefault();
        let searchValue = this.state.searchTxt;
           
        if(searchValue === ""){
            showToast("Please enter atlease 3 characters.", "top-right", "danger");
            return;
        }
        this.setState({
            searchTxt: ""
        })
        let iframe = document.getElementById('cloned_iframe');
        let hash = window.location.hash;
        //let formattedsearch = searchValue.replaceAll('#','</HASH>');
        let formattedsearch = searchValue.replace(/#/g, '</HASH>');
        const currentUrl = window.location.href;
        let iscrm = currentUrl.includes("/crm");
        let timeout = iscrm ? 1500 : 3000;
        if(iframe !== null && hash !== "#/settings"){
            let msgData = "gsearch|"+formattedsearch;
            iframe.contentWindow.postMessage(msgData, "*");
        } else {
            window.open(
                "#/crmsearch",
                '_self' // <- This is what makes it open in a new window.
            );
            setTimeout(() => {
                let iframe = document.getElementById('cloned_iframe');
                if(iframe != null){
                    let msgData = "gsearch|"+formattedsearch;
                    iframe.contentWindow.postMessage(msgData, "*");
                }
            }, timeout);
        }
    }

    onSearchTextChange = (e) => {
        let searchValue = e.target.value;
        this.setState({
            searchTxt: searchValue
        })
    }

    onUserAvailabilityStatusChange = async (e, status) => {
        this.setState({
            showUserLoader : true
        });
        let userFieldname = getSessionValue('USER_AVAILABILTITY_FIELD');
        let params = {
            "ENTITY" : "UPDATE_USER_STATUS",
            "OPERATION" : "UPDATE_USER_STATUS",
            "PLATFORM" : "Web",
            "status" : status,
            "userFieldName" : userFieldname,
        }

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            setSessionValue("userInfo_"+userFieldname, status);
            this.setState({
                openUserStatus : false,
                showUserLoader : false
            });
        }
    }


    render() {
        let loginUser = getSessionValue('loginusername');
        let loginEmail = getSessionValue('loginuseremail');
        let userAvailabilityStatus = getSessionValue('MAINTAIN_USER_AVAILABILITY');
        let userFieldName = getSessionValue('USER_AVAILABILTITY_FIELD');
        let notificationStatus = getSessionValue("web_notification_status");
        let userStatus = [];
        let currentStatus = "Active";
        let currentDBStatus = "Online";
        if(userFieldName !== "" && userAvailabilityStatus !== "" && userAvailabilityStatus !== null){
            userStatus = JSON.parse(userAvailabilityStatus);
            currentStatus = getSessionValue("userInfo_"+userFieldName);
            currentDBStatus = currentStatus;
            if(currentStatus !== "" && currentStatus !== null || currentStatus !== "null"){
                if(currentStatus === "Offline"){
                    currentStatus = "Away";
                } else {
                    currentStatus = userStatus[currentStatus];
                }
            }
        }
        let {dropDownIsOpen, searchActive, showLoader, openUserStatus, showUserLoader} = this.state;
        let loaderType = "ball-spin-fade-loader";
        return (
            <Fragment>
                <div className="header-btn-lg pe-0">
                
                    <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                            <div className="widget-content-left">
                                <a target={`_blank`} className={'hide'} onClick={(event => {this.openGivenUrl(event)})}><img className={'crmicon'} src={"crm.png"}/></a>
                                {Object.keys(userStatus).length > 0 && <UncontrolledButtonDropdown isOpen={openUserStatus} >
                                <DropdownToggle color="link" className="p-0" >
                                        <span className="user-availability" onClick={e => {this.setState({openUserStatus : !openUserStatus})}}>
                                            <div className='d-flex rounded-border'>
                                        <div className={cx({
          "online-bg": currentDBStatus === "Online",
          "offline-bg": currentDBStatus === "Offline",
        })} ></div>
                                        <span className="top-nav-btn">
                                            {currentStatus}
                                        </span>
                                        <FontAwesomeIcon className="opacity-8 n" icon={faAngleDown} />
                                        </div>
                                        </span>
                                    </DropdownToggle>
                                    <DropdownMenu end className="rm-pointers dropdown-menu-sm user-availability-dropdown">
                                        <Nav vertical>
                                        {
                                                    showUserLoader && 
                                                    <LoadingOverlay tag="div" active={showUserLoader}
                                                        styles={{
                                                            overlay: (base) => ({
                                                                ...base,
                                                                background: "#fff",
                                                                opacity: 0.5,
                                                                color: "red"
                                                            }),
                                                        }}
                                                        spinner={<Loader active={showUserLoader} type={loaderType} />}>
                                                    </LoadingOverlay>
                                                }
                                            {   Object.keys(userStatus).map((key)=>{
                                                    let status = userStatus[key];
                                                    return <NavItem>
                                                        <NavLink onClick={(e) => {this.onUserAvailabilityStatusChange(e, key)}}>
                                                        <div className={cx("mr-1",{
                                                            "online-bg": key === "Online",
                                                            "offline-bg": key === "Offline",
                                                        })} > </div>{status}
                                                        </NavLink>
                                                    </NavItem>
                                                })
                                            }                                            
                                        </Nav>
                                    </DropdownMenu>
                                </UncontrolledButtonDropdown>
                                }
                                { searchActive && 
                                    <div className='global-search-container'>
                                        <Form onSubmit={(e) => { this.performGlobalSearchOperation(e)}} name="searchForm" className={'global-search-form'}>
                                            <div className='input-container'>
                                                <input tabindex="1" placeholder="Search" class="topbandSearchInpt custom-width-5" maxlength="250" onKeyUp={(e) => {this.onSearchTextChange(e)}} onKeyDown={this.detectEnterPress} id="gsearchTextBox" name="searchword" autoComplete={"off"}/>
                                                <span onClick={(e) => { this.performGlobalSearchOperation(e) }} className='btn-go cursor-pointer' >GO</span>
                                                <span onClick={(e) => { this.globalSearchAction(e) }} className='close cursor-pointer' ><FontAwesomeIcon icon={faX} /></span>
                                            </div>
                                        </Form>
                                    </div> 
                                }
                                {
                                    <button onClick={(e) => { this.globalSearchAction(e) }} className="ignite-top-nav-wrap pl15-pr15-px cP filter-btn filter-active">
                                    <span className="top-nav-btn notification-icon search-filter z-index-r1">
                                        <FontAwesomeIcon className="opacity-8 bigin-sprite ignite-icon-notification" icon={faMagnifyingGlass} />
                                    </span>
                                    </button>
                                }
                                
                                <span className="ignite-top-nav-wrap pl10-pr10-px cP " onClick={(e) => { this.subscribeToNotification(e) }} >
                                {
                                                    showLoader && 
                                                    <LoadingOverlay tag="div" active={showLoader}
                                                        styles={{
                                                            overlay: (base) => ({
                                                                ...base,
                                                                background: "#fff",
                                                                opacity: 0.5,
                                                                color: "red"
                                                            }),
                                                        }}
                                                        spinner={<Loader active={showLoader} type={loaderType} />}>
                                                    </LoadingOverlay>
                                                }
                                    <CratioTooltip id={"notify-btn"} title={"Tap here to turn on web notifications."} content={<span className="top-nav-btn notification-icon  notify-btn">
                                            <FontAwesomeIcon className="opacity-8 bigin-sprite ignite-icon-notification" icon={faBell}/>
                                            <span className={cx("badge badge-dot badge-dot-sm badge-danger",{
                                                "notify-btn-badge-dot-success" : notificationStatus === "Subscribed",
                                                "notify-btn-badge-dot-danger" : notificationStatus !== "Subscribed"
                                            })}>Notifications</span>
                                        </span>
                                    }/>
                                </span>
                                <div ref={this.templateHolderRef}>
                                <UncontrolledButtonDropdown isOpen={dropDownIsOpen} >
                                    <DropdownToggle color="link" className="p-0" >
                                        <span className="ignite-top-nav-wrap cP" onClick={e => {this.setState({dropDownIsOpen : !dropDownIsOpen})}}>
                                        <span className="top-nav-btn">
                                            <span className="profile-img-wrap">
                                                <span className="ignite-profile-image pR">
                                                    <span className="pfbg-1 profile-bg pf-current-user">{getInitials(loginUser)}</span>
                                                </span>
                                            </span>
                                        </span>
                                        </span>
                                    </DropdownToggle>
                                    <DropdownMenu end className="rm-pointers dropdown-menu-md">
                                        <Nav vertical>
                                            <NavItem className='userbox-navitem-fxmark '>
                                                <span className='userBox-overflw' >{loginUser}</span>
                                                <span>
                                                    <FontAwesomeIcon icon={faXmark} onClick={e => {this.setState({dropDownIsOpen : !dropDownIsOpen})}} className='faxmark-userbox'/>
                                                </span> 
                                                <span className="tf-i">{loginEmail}</span>                                   
                                            </NavItem>
                                            <NavItem className={`hide`}>
                                                <NavLink href="#" onClick={this.showUserInfo}>
                                                    User Info
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink href="#" onClick={this.changePassword} >Change Password</NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink target="_blank" href="https://support.cratio.com/support/solutions">
                                                    Help Center
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink target="_blank" href="https://cratiocrm.com/support/">
                                                    Help Videos
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink target="_blank" href="https://support.cratio.com/support/tickets/new">
                                                    Support Ticket
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink target="_blank" href="https://remotedesktop.google.com/support/">
                                                     Remote Support
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink href="#" onClick={(e) => this.logoutApp(e)}>
                                                    <FontAwesomeIcon className="ms-2 opacity-8 bigin-sprite ignite-icon-notification hide" icon={faBell}/>
                                                    <span> Logout</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </DropdownMenu>
                                </UncontrolledButtonDropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default UserBox;
